import { Injectable, Inject } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
 
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { DataService }   from '../../shared-service/data.service';
import { BaseService }   from '../../shared-service/base.service';

@Injectable()
export class MyTasksService {	
  	public courseId:string="";
  	public learningType:string="";

  	constructor(private dataService:DataService, private bs: BaseService, private http: HttpClient,) {
		this.bs.log('info',"Loaded VideoLibraryService");
	}
	ApprovedeSignatureForCourse(body: Object, key: PropertyKey) {
		return new Promise((resolve, reject) => {
			let controllerMethod = 'learning/ApprovedeSignatureForCourse';
			this.dataService.doPostWithPromise(key, controllerMethod, body).then((data) => {
				resolve(data);
			},(err) => {reject(err);});
		});
	}

	getMenuListFromServer(body:Object,key:PropertyKey)
	{
		let promise=new Promise((resolve,reject)=>{
			let controllerMethod='MyLearning/MyLearningSideMenu';
			this.dataService.doPostWithPromise(key, controllerMethod, body).then( (data) => {
				this.bs.log('info',"Succes in getting result from "+controllerMethod);
				resolve(data);
			}, (err) => {
				this.bs.log('error',err);
				 this.bs.errorHandler(JSON.parse(err.error).Message);
				reject(err);
			}).catch((exception)=>{
				 this.bs.errorHandler(exception);
				reject(exception);
			});
		});
		return promise;
	};


	getSuggestionFromServer(body:Object,key:PropertyKey)
	{
		let promise=new Promise((resolve,reject)=>{
			let controllerMethod='Learning/GetMySuggestedLearning';
			this.dataService.doPostWithPromise(key, controllerMethod, body).then( (data) => {
				this.bs.log('info',"Succes in getting result from "+controllerMethod);
				resolve(data);
			}, (err) => {
				this.bs.log('error',err);
				 this.bs.errorHandler(JSON.parse(err.error).Message);
				reject(err);
			}).catch((exception)=>{
				 this.bs.errorHandler(exception);
				reject(exception);
			});
		});
		return promise;
	};

	getSuggestedSkillFromServer(body:Object,key:PropertyKey)
	{
		let promise=new Promise((resolve,reject)=>{
			let controllerMethod='Learning/GetMySuggestedCoursesBySkill';
			this.dataService.doPostWithPromise(key, controllerMethod, body).then( (data) => {
				this.bs.log('info',"Succes in getting result from "+controllerMethod);
				resolve(data);
			}, (err) => {
				this.bs.log('error',err);
				 this.bs.errorHandler(JSON.parse(err.error).Message);
				reject(err);
			}).catch((exception)=>{
				 this.bs.errorHandler(exception);
				reject(exception);
			});
		});
		return promise;
	};

	getOJTProgramListFromServer(body:Object,key:PropertyKey)
	{
		let promise=new Promise((resolve,reject)=>{
			let controllerMethod='CourseSurvey/GetOJTProgram';
			this.dataService.doPostWithPromise(key, controllerMethod, body).then( (data) => {
				this.bs.log('info',"Succes in getting result from "+controllerMethod);
				resolve(data);
			}, (err) => {
				this.bs.log('error',err);
				 this.bs.errorHandler(JSON.parse(err.error).Message);
				reject(err);
			}).catch((exception)=>{
				 this.bs.errorHandler(exception);
				reject(exception);
			});
		});
		return promise;
	};


	
	getOJTProgramNodeLearnerFromServer(body:Object,key:PropertyKey)
	{
		let promise=new Promise((resolve,reject)=>{
			let controllerMethod='CourseSurvey/GetOJTProgramNodeLearner';
			this.dataService.doPostWithPromise(key, controllerMethod, body).then( (data) => {
				this.bs.log('info',"Succes in getting result from "+controllerMethod);
				resolve(data);
			}, (err) => {
				this.bs.log('error',err);
				 this.bs.errorHandler(JSON.parse(err.error).Message);
				reject(err);
			}).catch((exception)=>{
				 this.bs.errorHandler(exception);
				reject(exception);
			});
		});
		return promise;
	};
	getOjtSurveyDetailsFromServer(body:Object,key:PropertyKey)
	{
		let promise=new Promise((resolve,reject)=>{
			let controllerMethod='CourseSurvey/GetOjtSurveyDetails';
			this.dataService.doPostWithPromise(key, controllerMethod, body).then( (data) => {
				this.bs.log('info',"Succes in getting result from "+controllerMethod);
				resolve(data);
			}, (err) => {
				this.bs.log('error',err);
				 this.bs.errorHandler(JSON.parse(err.error).Message);
				reject(err);
			}).catch((exception)=>{
				 this.bs.errorHandler(exception);
				reject(exception);
			});
		});
		return promise;
	};
	
	saveOjtSurveyAnswerToServer(body:Object,key:PropertyKey)
	{
		let promise=new Promise((resolve,reject)=>{
			let controllerMethod='CourseSurvey/SaveOjtSurveyAnswer';
			this.dataService.doPostWithPromise(key, controllerMethod, body).then( (data) => {
				this.bs.log('info',"Succes in getting result from "+controllerMethod);
				resolve(data);
			}, (err) => {
				this.bs.log('error',err);
				 this.bs.errorHandler(JSON.parse(err.error).Message);
				reject(err);
			}).catch((exception)=>{
				 this.bs.errorHandler(exception);
				reject(exception);
			});
		});
		return promise;
	};

	getSurveyPollResult(body: Object, key: PropertyKey)
	 {
	   return new Promise((resolve, reject) => {
		 this.dataService.doPostWithPromise(key, 'CourseSurvey/GetOjtSurveyPollResult', body).then((data)=> {
		  resolve(data);
		 }, (err) => { reject(err); });
	   });
	 }

	getTrendingKeywordFromServe(body: Object, key: PropertyKey) {
		let promise=new Promise((resolve,reject)=>{
			let controllerMethod='MyLearning/GetTrends';
			this.dataService.doPostWithPromise(key, controllerMethod, body).then( (data) => {
				this.bs.log('info',"Succes in getting result from "+controllerMethod);
				resolve(data);
			}, (err) => {
				this.bs.log('error',err);
				 this.bs.errorHandler(JSON.parse(err.error).Message);
				reject(err);
			}).catch((exception)=>{
				 this.bs.errorHandler(exception);
				reject(exception);
			});
		});
		return promise;
	};

	getTagFromServe(body: Object, key: PropertyKey) {
		let promise=new Promise((resolve,reject)=>{
			let controllerMethod='MyLearning/GetGlobalTags';
			this.dataService.doPostWithPromise(key, controllerMethod, body).then( (data) => {
				this.bs.log('info',"Succes in getting result from "+controllerMethod);
				resolve(data);
			}, (err) => {
				this.bs.log('error',err);
				 this.bs.errorHandler(JSON.parse(err.error).Message);
				reject(err);
			}).catch((exception)=>{
				 this.bs.errorHandler(exception);
				reject(exception);
			});
		});
		return promise;
	};

	SaveTagFromServe(body: Object, key: PropertyKey) {
		let promise=new Promise((resolve,reject)=>{
			let controllerMethod='MyLearning/InsertUpdateDeleteMyInterest';
			this.dataService.doPostWithPromise(key, controllerMethod, body).then( (data) => {
				this.bs.log('info',"Succes in getting result from "+controllerMethod);
				resolve(data);
			}, (err) => {
				this.bs.log('error',err);
				 this.bs.errorHandler(JSON.parse(err.error).Message);
				reject(err);
			}).catch((exception)=>{
				 this.bs.errorHandler(exception);
				reject(exception);
			});
		});
		return promise;
	};	
	

	getMyKpiDetailsFromServer(body: Object, key: PropertyKey) {
		let promise=new Promise((resolve,reject)=>{
			let controllerMethod='MyLearning/GetMyKpiDetails';
			this.dataService.doPostWithPromise(key, controllerMethod, body).then( (data) => {
				this.bs.log('info',"Succes in getting result from "+controllerMethod);
				resolve(data);
			}, (err) => {
				this.bs.log('error',err);
				 this.bs.errorHandler(JSON.parse(err.error).Message);
				reject(err);
			}).catch((exception)=>{
				 this.bs.errorHandler(exception);
				reject(exception);
			});
		});
		return promise;
	};

	getMyKpiChartDataFromServer(body: Object, key: PropertyKey) {
		let promise=new Promise((resolve,reject)=>{
			let controllerMethod='MyLearning/GetKpiChartData';
			this.dataService.doPostWithPromise(key, controllerMethod, body).then( (data) => {
				this.bs.log('info',"Succes in getting result from "+controllerMethod);
				resolve(data);
			}, (err) => {
				this.bs.log('error',err);
				 this.bs.errorHandler(JSON.parse(err.error).Message);
				reject(err);
			}).catch((exception)=>{
				 this.bs.errorHandler(exception);
				reject(exception);
			});
		});
		return promise;
	};

	//
	getLearningStatus(body: Object, key: PropertyKey) {
		let promise=new Promise((resolve,reject)=>{
			let controllerMethod='MyLearning/GetLearningStatus';
			this.dataService.doPostWithPromise(key, controllerMethod, body).then( (data) => {
				this.bs.log('info',"Succes in getting result from "+controllerMethod);
				resolve(data);
			}, (err) => {
				this.bs.log('error',err);
				 this.bs.errorHandler(JSON.parse(err.error).Message);
				reject(err);
			}).catch((exception)=>{
				 this.bs.errorHandler(exception);
				reject(exception);
			});
		});
		return promise;
	};
	//	
	updateStoreData(key: PropertyKey, data: Object) {
		return this.dataService.setStoreData(key, data);
	}

	getStoreData(key: PropertyKey) {
		return this.dataService.getDataStoreData(key);
	}

	GetChannelLearningData(body: Object, key: PropertyKey) {
		let promise=new Promise((resolve,reject)=>{
			let controllerMethod='Learning/GetChannelLearnings';
			this.dataService.doPostWithPromise(key, controllerMethod, body).then( (data) => {
				this.bs.log('info',"Succes in getting result from "+controllerMethod);
				resolve(data);
			}, (err) => {
				this.bs.log('error',err);
				 this.bs.errorHandler(JSON.parse(err.error).Message);
				reject(err);
			}).catch((exception)=>{
				 this.bs.errorHandler(exception);
				reject(exception);
			});
		});
		return promise;
	};

    GetProgrammableChannelData(body: Object, key: PropertyKey) {
	
		let promise=new Promise((resolve,reject)=>{
			let controllerMethod='Learning/GetProgrammableChannelsForWeb';
			this.dataService.doPostWithPromise(key, controllerMethod, body).then( (data) => {
				this.bs.log('info',"Succes in getting result from "+controllerMethod);
				resolve(data);
			}, (err) => {
				this.bs.log('error',err);
				 this.bs.errorHandler(JSON.parse(err.error).Message);
				reject(err);
			}).catch((exception)=>{
				 this.bs.errorHandler(exception);
				reject(exception);
			});
		});
		return promise;
	};

	GetChanneCardDetailsData(body: Object, key: PropertyKey) {

		let promise = new Promise((resolve, reject) => {
			let controllerMethod = 'Learning/ChannelCardsDetails';
			this.dataService.doPostWithPromise(key, controllerMethod, body).then((data) => {
				this.bs.log('info', "Succes in getting result from " + controllerMethod);
				resolve(data);
			}, (err) => {
				this.bs.log('error', err);
				this.bs.errorHandler(JSON.parse(err.error).Message);
				reject(err);
			}).catch((exception) => {
				this.bs.errorHandler(exception);
				reject(exception);
			});
		});
		return promise;
	};	
}
